<template>
  <div>
    <b-modal id="otp_modal" modal-class="" centered hide-header hide-footer>
      <div class="modal-base totop-div">
        <!-- <div class="logo-header">
                    <img
                        class="icon-logo"
                        src="../../assets/img/logochanel.png"
                    />
                </div> -->
        <top-bar class="topbar"></top-bar>
        <div
          class="wrapper-body-otp totop-div"
          v-if="objOTPError && !objOTPError.isShowError"
        >
          <div class="otp-headline">{{ lbl.otp.headline }}</div>
          <div class="otp-info">
            <div class="otp-txt" v-html="lbl.otp.line1"></div>
            <div class="otp-txt">{{ lbl.otp.line2 }}</div>
          </div>
          <div class="otp-input">
            <input
              type="tel"
              v-if="objOTP"
              v-model="objOTP.otp"
              maxlength="6"
              @input="onChange()"
            />
          </div>
          <div class="otp-error">
            <div
              class="otp-error-txt"
              v-if="objOTPTimer && !objOTPTimer.isTimeExpired"
            >
              {{ lbl.otp.time_left1 }} {{ objOTPTimer.time_left }} นาที
            </div>
          </div>
          <div class="otp-resend">
            <div
              class="otp-resend-txt"
              v-if="objOTP && objOTP.isShowResendOTP"
              @click="resendOtp()"
            >
              {{ lbl.otp.resend_line2 }}
            </div>
          </div>
          <div class="otp-submit">
            <div class="btn-submit" @click="submitOtp()">ยืนยัน</div>
          </div>
        </div>
        <div
          class="wrapper-body-otp error"
          v-if="objOTPError && objOTPError.isShowError"
        >
          <div class="error-info">
            <div class="error-headline">{{ lbl.otp.headline_error }}</div>
            <div
              class="error-message"
              v-if="objOTPError"
              v-html="objOTPError.strMessage"
            ></div>
            <div class="error-submit" v-show="!isSendAgain">
              <div class="btn-error" @click="againOtp()">
                {{ lbl.otp.again }}
              </div>
            </div>
            <div class="error-submit" v-show="isSendAgain">
              <div class="btn-error" @click="againRegister()">
                {{ lbl.otp.newregis }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <modal view="otp" :busModal="busModal"></modal>
  </div>
</template>
<script>
import Vue from "vue";
import Util from "@/helper/Utility.js";
import Moment from "moment";
import OtpModel from "@/model/OtpModel.js";
import Otp from "@/helper/OtpHelper.js";
import Modal from "@/components/modal/Modal.vue";

import Register from "@/helper/RegisterHelper.js";
import Account from "@/helper/AccountHelper.js";
import TopBar from "@/components/TopBar.vue";

/**
 * Property
 * @property {object} lbl (required) Text for component.
 * @property {object} busOtpModal (required) Modal Controller.
 * Method
 * @method initialOtpModal Setup otp modal with campaign.
 * @method closeOtpModal Stop interval and close modal.
 * Interval
 * @method startInterval Start otp interval.
 * @method stopInterval Stop otp interval.
 * @method otpTimeExpired Set otp modal to expired state.
 * @method runOTPInterval Setup time information and start interval.
 * @method timeFormatter Format timestamp to count down timer.
 */

export default {
  name: "OtpModal",
  components: {
    Modal,
    TopBar,
  },
  props: {
    lbl: Object,
    busOtpModal: Object,
  },
  data: function () {
    return {
      objOTP: null,
      objOTPTimer: null,
      objOTPError: null,
      interval: null,
      objauthRequestOTPConfig: {},
      isRequestOTPBtnEnable: false,
      isSendOTPBtnEnable: false,
      numOTPTime: 180,
      busModal: new Vue(),
      isSendAgain: false,

      registerHelper: new Register(),
    };
  },
  mounted: function () {
    this.busOtpModal.$on("showOtpModal", this.initialOtpModal);
    this.busOtpModal.$on("hideOtpModal", this.closeOtpModal);
    this.busOtpModal.$on("showErrorOtpModal", this.showError);

    console.log("asdasd", this.$configModalNoConnect);

    setTimeout(() => {
      window.scrollTo(0, 0);
      //document.getElementByClassName("totop-div").scrollTop = 0
    }, 500);
  },
  methods: {
    initialOtpModal: function (objauthRequestOTPConfig) {
      this.objauthRequestOTPConfig = objauthRequestOTPConfig;
      this.objOTP = new OtpModel.OTPModelBuilder().create();
      this.objOTPError = new OtpModel.OTPErrorModelBuilder().create();
      this.objOTPTimer = new OtpModel.OTPTimerModelBuilder().create();
      this.busModal.$emit("showLoadingModal");

      Otp.requestOTP(this.objOTP, this.objauthRequestOTPConfig)
        .then((objResult) => {
          this.busModal.$emit("hideLoadingModal");
          Util.log(objResult);
          this.isSendOTPBtnEnable = false;
          this.runOTPInterval(this.numOTPTime);
          this.$bvModal.show("otp_modal");
        })
        .catch((error) => {
          this.busModal.$emit("hideLoadingModal");
          this.otpTimeExpired();
          if (error.response) {
            this.showError(error);
            this.$bvModal.show("otp_modal");
          } else {
            this.showErrorInternet();
            //this.busModal.$emit("showAlertModal", this.$configModalNoConnect);
          }
        });
    },
    submitOtp: function () {
      //this.state = "error";
      window.scrollTo(0, 0);
      //document.getElementByClassName("totop-div").scrollTop = 0
      this.$emit("modalSubmitOtp", this.objOTP);
    },
    resendOtp: function () {
      this.busModal.$emit("showLoadingModal");
      this.objOTP.isShowResendOTP = false;
      
      Otp.requestOTP(this.objOTP, this.objauthRequestOTPConfig)
        .then((objResult) => {
          this.busModal.$emit("hideLoadingModal");
          Util.log(objResult);
          this.isSendOTPBtnEnable = false;
          this.runOTPInterval(this.numOTPTime);
        })
        .catch((error) => {
          if (error.response) {
            this.busModal.$emit("hideLoadingModal");
            this.showError(error);

          } else {
            this.showErrorInternet();
          }
          
        });
    },
    showError: function (objError) {
      if (objError && objError.response.data && objError.response.data.error) {
        this.objOTP.otp = "";
        if (
          objError.response.data.error.code == 409 &&
          objError.response.data.error.id == 2091
        ) {
          this.objOTPError.strMessage = this.lbl.otp.invalid_otp_error;
          this.objOTPError.isShowError = true;
        } else if (objError.response.data.error.id == 2092) {
          this.isSendAgain = true;
          this.objOTPError.strMessage = this.lbl.otp.otp_expire;
          this.objOTPError.isShowError = true;
        } else if (
          objError.response.data.error.message == "Exceed registration time"
        ) {
          this.isSendAgain = true;
          this.objOTPError.strMessage = this.lbl.otp.register_time;
          this.objOTPError.isShowError = true;
        } else if (
          objError.response.data.error.message == "Exceed OTP fail limit"
        ) {
          this.isSendAgain = true;
          this.objOTPError.strMessage = this.lbl.otp.register_limit;
          this.objOTPError.isShowError = true;
        } else {
          this.objOTPError.strMessage = objError.response.data.error.message;
          this.objOTPError.isShowError = true;
        }
      } else {
        this.objOTPError.strMessage = this.lbl.otp.msg_error;
        this.objOTPError.isShowError = true;
      }
    },
    showErrorInternet: function () {
        var configModal = {
            title: null,
            message: "พบปัญหาการเชื่อมต่อ",
            strBtnOk: "ปิด",
            tag: "nointernet",
        };
        this.busModal.$emit('showAlertModal', configModal);
    },
    authStart: function () {
      var token = Account.getToken();
      this.registerHelper.authStart(token).catch((error) => {
        this.busModal.$emit("hideLoadingModal");
        this.busModal.$emit("showAlertModal", error);
      });
    },
    againRegister: function () {
      this.$bvModal.hide("otp_modal");
      this.authStart();
      this.isSendAgain = false;
    },
    againOtp: function () {
      this.resendOtp();
      this.objOTPError = new OtpModel.OTPErrorModelBuilder().create();
    },
    closeOtpModal: function () {
      this.stopInterval();
      this.$bvModal.hide("otp_modal");
    },
    runOTPInterval: function (numExpireIn) {
      this.objOTP.isShowResendOTP = false;
      this.objOTPTimer = Otp.SetRunOTPTimer(numExpireIn);
      console.log(this.objOTPTimer);
      this.startInterval();
    },
    startInterval: function () {
      this.stopInterval();
      var self = this;
      this.timeFormatter(false, false, ":");
      this.interval = setInterval(function () {
        self.timeFormatter(false, false, ":");
      }, 1000);
    },
    stopInterval: function () {
      clearInterval(this.interval);
    },
    otpTimeExpired: function () {
      this.isSendOTPBtnEnable = false;

      this.objOTP.isShowResendOTP = true;
      this.objOTPTimer.isTimeExpired = true;

      this.stopInterval();
    },
    timeFormatter: function (isShowDay, isShowHour, strSeparator) {
      var numTimeDiff =
        Moment.unix(this.objOTPTimer.numExpireDate) -
        Moment.unix(this.objOTPTimer.numCurrentDate);
      //Timer Expired
      if (numTimeDiff <= 0) {
        numTimeDiff = 0;
        this.otpTimeExpired();
      }

      //Add 1 second to current date.
      this.objOTPTimer.numCurrentDate++;

      //Calculate day.
      var numDayDiff = Math.floor(numTimeDiff / 1000 / 60 / 60 / 24);
      var haveDay = parseInt(numDayDiff) <= 0 ? false : true;
      if (isShowDay) numTimeDiff -= numDayDiff * 1000 * 60 * 60 * 24;

      //Calculate hour.
      var numHourDiff = Math.floor(numTimeDiff / 1000 / 60 / 60);
      var haveHour = parseInt(numHourDiff) <= 0 ? false : true;
      if (isShowHour) numTimeDiff -= numHourDiff * 1000 * 60 * 60;

      if (numHourDiff <= 9) numHourDiff = "0" + numHourDiff;

      //Calculate minute.
      var numMinuteDiff = Math.floor(numTimeDiff / 1000 / 60);
      var haveMinute = parseInt(numMinuteDiff) <= 0 ? false : true;
      numTimeDiff -= numMinuteDiff * 1000 * 60;

      if (numMinuteDiff <= 9) numMinuteDiff = "0" + numMinuteDiff;

      //Calculate second.
      var numSecondDiff = "" + Math.floor(numTimeDiff / 1000);
      var haveSecond = parseInt(numSecondDiff) <= 0 ? false : true;
      if (numSecondDiff <= 9) numSecondDiff = "0" + numSecondDiff;

      var strTimeLeft = "";
      if (isShowDay) {
        if (haveDay) strTimeLeft += numDayDiff + strSeparator;
        else strTimeLeft += "00" + strSeparator;
      }

      if (isShowHour) {
        if (haveHour) strTimeLeft += numHourDiff + strSeparator;
        else strTimeLeft += "00" + strSeparator;
      }

      //Always show minute.
      if (haveMinute) strTimeLeft += numMinuteDiff + strSeparator;
      else strTimeLeft += "00" + strSeparator;

      //Always show second.
      if (haveSecond) strTimeLeft += numSecondDiff;
      else strTimeLeft += "00";

      this.objOTPTimer.time_left = strTimeLeft;
    },
    onChange: function () {
      this.objOTP.otp = this.objOTP.otp.replace(Vue.RegExp.emoji, "");
      this.objOTP.otp = this.objOTP.otp.replace(/[^0-9]/g, "");
    },
  },
};
</script>
<style lang="scss">
@import "@/style/base/component/modal/modal.scss";
@import "@/style/base/component/modal/otp.scss";
</style>
